import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { NgTemplateAssertTypeModule } from '@recruitee/common';

import { TooltipModule } from '../../common/tooltip/tooltip.module';
import { TypeaheadModule } from '../typeahead/typeahead.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { TaggerComponent } from './tagger.component';

@NgModule({
  exports: [TaggerComponent],
  imports: [
    TypeaheadModule,
    CommonModule,
    RtUICoreOverlayModule,
    NgTemplateAssertTypeModule,
    ReactiveFormsModule,
    TooltipModule,
    TaggerComponent,
  ],
})
export class TaggerModule {}
export { TaggerComponent, TaggerTag, TypeaheadSuggestionsContext } from './tagger.component';
